import CookieHelper from '../../00_utilities/helpers/CookieHelper';
import BreakpointHelper from '../../00_utilities/helpers/BreakpointHelper';
import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';

class Sidebar {
    constructor(elem) {
        this.elem = elem;
        this.itemContainer = this.elem.querySelector('.sidebar__container');
        this.breakpoint = this.itemContainer.scrollWidth + 30;
        this.aboveBreakpoint = BreakpointHelper.aboveBreakpoint(this.breakpoint);
        this.chatLink = document.getElementById('sidebar-live-chat-link');
        this.alveni = document.getElementById('sidebar-alveni');
        this.snapABug = [];
        this.snapEngage = [];
        this.snapEngageLoaded = false;
        this.script = undefined;
        this.sidebarClickListener = this.toggleSidebar.bind(this);
        this.bodyClickListener = this.bodyClick.bind(this);
        this.inactiveClass = 'sidebar__item--inactive';
    }

    init() {
        if (this.chatLink) {
            // if approved before or marketing cookies are approved
            if (CookieHelper.getCookieValue('consent-type-marketing') === 'true'
                || CookieHelper.getCookieValue('consent-type-snap-engage')) {
                this.initSnapEngage();
            }

            window.addEventListener('consent-type-snap-engage', this.initSnapEngage.bind(this));
        }

        if (this.alveni) {
            if (CookieHelper.getCookieValue('consent-type-marketing') === 'true'
                || CookieHelper.getCookieValue('consent-type-alveni')) {
                this.initAlveniButton();
            }
            window.addEventListener('consent-type-alveni', this.initAlveniButton.bind(this));
        }

        this.handleResizeSensitiveBehaviour();

        this.elem.classList.add('sidebar--initialized');
    }

    handleResizeSensitiveBehaviour() {
        window.addEventListener('resize', GeneralHelper.throttle(() => {
            this.handleBreakpointCrossing();
        }, 300));

        if (!this.aboveBreakpoint) {
            this.elem.classList.add('sidebar--overflowing');

            document.addEventListener('click', this.sidebarClickListener);
            document.addEventListener('click', this.bodyClickListener);
        }
    }

    toggleSidebar() {
        this.elem.classList.toggle('sidebar--open');
    }

    bodyClick(e) {
        const { target } = e;
        const isNavigation = (target.closest('.sidebar') !== null
            || document.querySelector('.sidebar') === target);

        if (!isNavigation) {
            this.elem.classList.remove('sidebar--open');
        }
    }

    handleBreakpointCrossing() {
        const breakpointInfo = BreakpointHelper.breakpointCrossed(
            this.breakpoint, this.aboveBreakpoint,
        );
        this.aboveBreakpoint = breakpointInfo.aboveBreakpoint;
        const { breakpointCrossed } = breakpointInfo;

        if (breakpointCrossed && !this.aboveBreakpoint) {
            this.elem.classList.add('sidebar--overflowing');
            document.addEventListener('click', this.sidebarClickListener);
            document.addEventListener('click', this.bodyClickListener);
            return;
        }
        if (breakpointCrossed && this.aboveBreakpoint) {
            this.elem.classList.remove('sidebar--overflowing');
            document.removeEventListener('click', this.sidebarClickListener);
            document.removeEventListener('click', this.bodyClickListener);
        }
    }

    initSnapEngage() {
        if (!CookieHelper.getCookieValue('consent-type-snap-engage')) {
            CookieHelper.setCookie('consent-type-snap-engage', true);
        }
        window.addEventListener('consent-withdraw-snap-engage', this.removeSnapEngage.bind(this));

        if (!this.snapEngageLoaded || typeof this.script === typeof undefined) {
            this.addLiveChatScript();
        }

        if (this.snapEngage) {
            this.chatLink.addEventListener('click', () => {
                this.snapEngage.startLink();
            });
        }
    }

    removeSnapEngage() {
        if (this.snapEngage) {
            this.snapEngage.clearAllCookies();
        }
        this.chatLink.classList.add(this.inactiveClass);
        this.snapEngageLoaded = false;
        if (this.script) {
            this.script.src = '';
            this.script.parentElement.removeChild(this.script);
            this.script = undefined;
        }

        CookieHelper.clearCookie('consent-type-snap-engage');
    }

    addLiveChatScript() {
        this.script = document.createElement('script');

        // eslint-disable-next-line max-len
        this.script.src = 'https://storage.googleapis.com/code.snapengage.com/js/9f07aa1c-6d45-4143-a9f3-964c010d4dbf.js';
        this.script.defer = true; // fallback if browser does not support async
        this.script.async = true;

        document.body.appendChild(this.script);

        this.script.onload = () => {
            this.snapEngageLoaded = this.initLiveChat(this.snapEngageLoaded);
        };
        this.script.onreadystatechange = () => {
            this.snapEngageLoaded = this.initLiveChat(this.snapEngageLoaded);
        };
    }

    /**
     * https://developer.snapengage.com/javascript-api/
     * @param done
     * @returns {boolean}
     */
    initLiveChat(done) {
        this.snapABug = window.SnapABug;
        this.snapEngage = window.SnapEngage;

        if (!done && (!this.script.readyState
            || this.script.readyState === 'loaded'
            || this.script.readyState === 'complete')
        ) {
            done = true;
            this.setLiveChatStatus();
        }
        return done;
    }

    setLiveChatStatus() {
        if (this.snapEngage) {
            this.snapEngage.getAgentStatusAsync((online) => {
                if (online) {
                    this.chatLink.classList.remove(this.inactiveClass);
                } else {
                    this.chatLink.classList.add(this.inactiveClass);
                }
            });
        }
    }

    initAlveniButton() {
        if (!CookieHelper.getCookieValue('consent-type-alveni')) {
            CookieHelper.setCookie('consent-type-alveni', true);
        }

        this.alveni.classList.remove(this.inactiveClass);

        const iframe = this.alveni.querySelector('iframe');
        if (!iframe) {
            return;
        }

        if (!sessionStorage.getItem('alveniClosed')) {
            iframe.classList.add('iframe-alveni--show');
        }

        this.alveni.addEventListener('click', () => {
            if (!sessionStorage.getItem('alveniClosed')) {
                sessionStorage.setItem('alveniClosed', 'true');
            }
            iframe.classList.toggle('iframe-alveni--show');
        });

        if (this.itemContainer) {
            this.breakpoint = this.itemContainer.scrollWidth + 30;
        }
    }
}

export default Sidebar;
